import Alpine from 'alpinejs';
import { VideoInfo } from './video_info';

Alpine.data('videoInfo', () => new VideoInfo());
